<div class="container user-info-box">
  <!-- <div class="user-info-box-item">{{ 'header.welcome.text' | translate }}</div> -->
  <div class="user-info-box-item login-status">
    <custom-login-status view="full" class="login-status"></custom-login-status>
  </div>

  <div *ishFeature="'orderTemplates'" class="user-info-box-item">
    <a routerLink="/account/order-templates"> Order Templates <i class="icon-heart"></i></a>
  </div>

  <div *ishFeature="'compare'" class="user-info-box-item">
    <ish-lazy-product-compare-status view="full"></ish-lazy-product-compare-status>
  </div>

  <div *ishFeature="'wishlists'" class="user-info-box-item">
    <ish-lazy-wishlists-link view="auto"></ish-lazy-wishlists-link>
  </div>

  <!-- Hide language switch in the dotcms edit view. We can use dotcms language switch in the edit view -->
  <div *ngIf="!isInsideIframe()" class="user-info-box-item">
    <custom-language-switch view="accordion" placement="up"></custom-language-switch>
  </div>
</div>
